module.exports = __webpack_public_path__ + "static/media/EndServiceIcon.950e7175.png";